import React from 'react';
import { useCareRecDescriptionGroups } from './careRecDescriptions';
import { CareRecDescriptionGroup } from './CareRecDescriptionGroup';
export var CareRecSlideoverContent = function () { return (React.createElement(React.Fragment, null, useCareRecDescriptionGroups().map(function (careRecDescriptionGroup) { return (React.createElement(CareRecDescriptionGroup, { careRecDescriptionGroup: careRecDescriptionGroup, key: careRecDescriptionGroup.id })); }))); };
export default CareRecSlideoverContent;
